<template>
    <div class="notice-content">
        <!-- <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#F2F4F6">通知类型</me-notice-bar>
        <div class="types">
            <me-button type="primary" size="small" color="#06B455">短信</me-button>
            <me-button type="primary" size="small" color="#06B455" class="not-yet">二手车APP</me-button>
            <me-button type="primary" size="small" color="#06B455" class="not-yet">邮件</me-button>
        </div> -->
        <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">基础信息</me-notice-bar>
        <div class="content base_content">
            <me-cell-group class="defined-group">
                <me-cell class="defined-cell" title="问卷名称" :value="pageName"/>
                <me-cell class="defined-cell" title="是否匿名" :value="loginTypeName"/>
                <me-cell class="defined-cell cell_bottom" title="通知类型" :value="sendType.text" is-link @click.prevent="showPopNotice"/>
            </me-cell-group>
        </div>
        <div v-if="sendType.value !== 'MsgExternal'">
            <div class="content base_content" style="padding-top: 0px">
                <me-cell-group class="defined-group">
                    <me-cell class="defined-cell cell_bottom" title="发送范围" is-link :value="haveRange ? '已设置': '未设置'" @click.prevent="jumpSendRange"/>
                    <div class="defined-span" v-show="sendType.value === 'RemindTask'">{{'发送后，问卷将以流程的待办任务的方式，通知到指定人员;'}}</div>
                </me-cell-group>
            </div>
        </div>
        <div v-if="sendType.value === 'MsgExternal' || sendType.value === 'MsgInternal'">
            <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">短信签名</me-notice-bar>
            <div class="content">
                <me-cell-group class="defined-group">
                    <me-cell class="defined-cell" title="签名" is-link :value="showSign.text" @click.prevent="showPopSign"/>
                    <me-field
                        v-if="showSign.dicValue === 'user_custom'"
                        class="defined-field defined-cell"
                        v-model="customSignId"
                        input-align="right"
                        maxlength="50"
                        label="模版服务ID"
                        placeholder="请填写短信平台模版中的服务ID"
                    />
                    <div class="desc-tip" v-if="showSign.dicValue === 'user_custom'"><span>说明：</span>如内容带有手机号、链接的短信，有被短信供应商拦截风险，请到短信平台申请模版并报备，短信模版选【自定义短信平台模版】</div>
                    <div class="send-tip" v-if="showSign.dicValue === 'user_custom'" @click="showTipDesc"><me-icon name="info-o" class="info-o"/>短信模版如何配置？</div>
                </me-cell-group>
            </div>
        </div>
        <div v-if="sendType.value !== 'RemindTask'">
            <me-notice-bar color="rgba(69, 90, 100, 0.6)" background="#f7f7f7">{{sendType.value === 'IMChart' ? '呱呱消息内容' : '短信内容'}}</me-notice-bar>
            <div class="content_text content" v-if="showSign.dicValue !== 'user_custom' || sendType.value === 'IMChart'">
                <span class="desc">正文中插入：</span>
                <div class="texts">
                    <span @click="insert('手机号')">手机号</span>
                    <span @click="insert('扩展字段2')">扩展字段2</span>
                    <span @click="insert('扩展字段3')">扩展字段3</span>
                    <span @click="insert('扩展字段4')">扩展字段4</span>
                    <span @click="insert('问卷链接')">问卷链接</span>
                </div>
                <div class="tip"><span>注意：</span>请不要修改{{}}中的内容，系统会根据问卷自动替换。</div>
                <me-field
                    ref="textareaContent"
                    v-model="smsContent"
                    label=""
                    placeholder=""
                    title-position="top"
                    type="textarea"
                    maxlength="300"
                    autosize
                    rows="10"
                    show-word-limit
                />
            </div>
            <div class="content base_content" v-else>
                <div class="desc-tip" style="padding-top: 10px;"><span>说明：</span>请选择短信平台中自定义短信模版中使用的变量：</div>
                <me-cell-group class="defined-group">
                    <me-cell
                        center
                        :title="item.fieldName"
                        class="defined-cell"
                        v-for="(item, index) in smsContentList"
                        :key="index"
                    >
                        <template #right-icon>
                            <me-switch
                                v-model="item.enabled"
                                active-value="1"
                                inactive-value="0"
                                active-color="#06B455"
                                inactive-color="#DBDBDB"
                                size="24"/>
                        </template>
                    </me-cell>
                </me-cell-group>
            </div>
        </div>
        <div class="content">
            <div class="send-tip" @click="showTip" v-show="sendType.value === 'MsgExternal'"><me-icon name="info-o" class="info-o"/>发送提示</div>
        </div>
        <confirm
            @confirm="confirm"
            @cancel="save"
            :btns="true"
            cancelText="保存内容"
            :text="sendType.value === 'MsgExternal' ? '导入发送名单' : '发送'"/>
        <me-popup v-model="show" position="bottom">
            <bottomConfirm
                :btns="true"
                text="立即发送"
                @cancel="cancelPop"
                @confirm="confirmPop"
                @close="close">
                <div class="dialog-content">
                    <div class="file" v-if="file">
                        <span class="fileName">{{file.file.name}}</span>
                        <span class="del" @click="file=null">删除</span>
                    </div>
                    <me-uploader
                        :after-read="afterRead"
                        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        :max-size="1*1024*1024"
                        @oversize="onOversize">
                        <span class="import-btn">{{file ? '重新导入' : '导入'}}</span>
                    </me-uploader>
                    <span @click="down" class="down">下载模板</span>
                    <div class="notice">
                        <span>
                            注：
                        </span>
                        <div>
                            <span>1、每次只能发送一个附件且附件小于1M</span>
                            <div>2、导入时，若ext1为C01格式的密文手机号，ext3必须填写车源号，否则不符合业务审计，短信会发送失败</div>
                            <div>3、导入时，若ext1为userId，ext5必须加上 {"ext1Flag":"userId"}，否则短信会发送失败</div>
                            <div>4、userId为18位的纯数字，如：152647043707500042</div>
                        </div>
                    </div>
                </div>
            </bottomConfirm>
        </me-popup>
        <me-popup v-model="showPopup1" round position="bottom">
            <me-picker
                    title="选择签名"
                    show-toolbar
                    :columns="columns"
                    :default-index="defaultPickIndex"
                    @confirm="onConfirmPicker"
                    @cancel="onCancelPicker"
                    />
        </me-popup>
        <me-popup v-model="showPopup2" round position="bottom">
            <me-picker
                    title="选择通知类型"
                    show-toolbar
                    :columns="columnsNotice"
                    :default-index="defaultPickSendTypeIndex"
                    @confirm="(data)=>onConfirmPicker(data, 'sendType')"
                    @cancel="onCancelPicker"
                    />
        </me-popup>
    </div>
</template>
<script>
import { addClass2, removeClass2 } from '@/util/status-util'
import { Toast } from '@guazi-fe/melon'
import confirm from '../compontents/confirm.vue'
import bottomConfirm from '../compontents/bottom_confirm.vue'
import { Dialog, Cell, CellGroup} from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import browser from '@/util/browser'
import NativeApi from 'native-api'

const defaultOptions =  {
        "dicId": "50",
        "dicKey": "【瓜子二手车】",
        "dicValue": "ws5d80a67708bd4",
        "dicDesc": "【瓜子二手车】签名"
    }
export default {
    name: 'notice-content',
    data() {
        return {
            customSignId: '',
            smsContent: '',
            show: false,
            file: null,
            signInfo: {
                text: defaultOptions.dicKey,
                value: defaultOptions.dicValue,
                ...defaultOptions,
            },
            signOptions: [],
            showPopup1: false, // 签名popup
            showPopup2: false, // 通知类型popup
            pageName: '', // 问卷名称
            loginTypeName: '', // 是否匿名
            columnsNotice: [
                {
                    text: '短信（非员工）',
                    value: 'MsgExternal',
                },
                {
                    text: '短信（员工）',
                    value: 'MsgInternal',
                },
                {
                    text: '呱呱公众号',
                    value: 'IMChart',
                },
                {
                    text: '流程待办任务',
                    value: 'RemindTask',
                },
            ], // 通知类型
            sendType: {
                text: '短信（非员工）',
                value: 'MsgExternal'
            },
            haveRange: false,
            smsContentList: [
                {
                    "fieldCode": "phone",
                    "fieldName": "{$phone}手机号",
                    "enabled": "1"
                }, {
                    "fieldCode": "ext2",
                    "fieldName": "{$ext2}扩展字段2",
                    "enabled": "1"
                }, {
                    "fieldCode": "ext3",
                    "fieldName": "{$ext3}扩展字段3",
                    "enabled": "1"
                }, {
                    "fieldCode": "ext4",
                    "fieldName": "{$ext4}扩展字段4",
                    "enabled": "1"
                }, {
                    "fieldCode": "pageUrl",
                    "fieldName": "{$pageUrl}问卷链接",
                    "enabled": "1"
                }
            ],
        }
    },
    mixins: [mixin],
    components: { 
        confirm, 
        bottomConfirm,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        columns() {
            return this.signOptions.map(item => ({
                value: item.dicValue,
                text: item.dicKey,
                ...item,
            }))
        },
        defaultPickIndex() {
            let index = 0
            this.signOptions.forEach((item, i)=>{
                if(item.dicValue  === this.signInfo.value){
                    index = i
                }
            })
            return index
        },
        defaultPickSendTypeIndex() {
            let index = 0
            this.columnsNotice.forEach((item, i)=>{
                if(item.value === this.sendType.value){
                    index = i
                }
            })
            return index
        },
        showSign() {
            let signInfo = this.signInfo
            let item = this.signOptions.find(item => signInfo.value === item.dicValue)
            if(item){
                return {
                    value: item.dicValue,
                    text: item.dicKey,
                    ...item,
                }
            }
            return signInfo
        },
    },
    created() {
        this.getData()
        this.getSignOptions()
    },
    methods: {
        showTipDesc() {
            const message = `<div style="text-align:left;color:#333;font-size: .37rem;">短信平台模板配置提示：\n地址：\n<a href="https://pangu.guazi-apps.com/sms-service-kcp/sms_template" style="color: #06B455;">https://pangu.guazi-apps.com/sms-service-kcp/sms_template</a>。\n若无权限，先申请【短信平台】权限。\n地址：\n<a href="https://spc.guazi-apps.com/#/apply/edit?permissionType=0" style="color: #06B455;">https://spc.guazi-apps.com/#/apply/edit?permissionType=0</a>。\n详细配置地址：\n<a href="https://cwiki.guazi.com/pages/viewpage.action?pageId=561291753" style="color: #06B455;">https://cwiki.guazi.com/pages/viewpage.action?pageId=561291753</a>。\n\n模板示例：\n参与调研得10元用户回访金！了解您在瓜子卖车的服务感受，帮助我们提供更好的服务，感谢您的反馈！（用户回访金预计在调研结束后的7个工作日内发放）{$pageUrl}</div>`
            Dialog.alert({
                title: '',
                message,
                }).then(() => {
            })
        },
        jumpSendRange() {
            if (!this.haveRange) {
                return
            }
            this.$router.push({
                name: 'sendingRange',
                params: {
                    pageId: this.pageId,
                },
                query: {
                    readonly: '1'
                }
            })
        },
        down() {
            const { guaguaApp } = browser
            const data = {
                tid: this.tid,
            }
            const downUrl = location.protocol + Questionnaire.exportCustomer(data) + '&v=' + new Date().getTime()
            var date = new Date()
            if (guaguaApp) {
                 NativeApi.invoke('downloadFile', {
                    fileUrl: downUrl,
                    fileName: `发送用户信息导入模板-${date.getFullYear()}${date.getMonth()+1}${date.getDate()}${Math.round(Math.random(100000)*899999)}.xlsx`,
                })
                return
            }
            window.open(downUrl)
        },
        getData() {
            const data = {
                tid: this.tid,
                pageId: this.pageId,
            }
            Questionnaire.getQuestionConfig(data).then((res) => {
                let { data: { data: { smsContent, signType, pageName, loginType, loginTypeName, sendType, sendTypeName, haveRange, customSignId } } } = res
                if(signType) {
                    this.signInfo = {
                        value: signType,
                    }
                }
                if (signType === 'user_custom' && (sendType == 'MsgExternal' || sendType === 'MsgInternal')) {
                    this.customSignId = customSignId
                    let smsContentList = JSON.parse(smsContent)
                    this.smsContentList.forEach(item => {
                        smsContentList.forEach(obj => {
                            if (item.fieldCode === obj.fieldCode) {
                                item.enabled = obj.enabled
                            }
                        })
                    })
                } else {
                    this.smsContent = smsContent
                }
                this.loginType = loginType
                this.pageName = pageName || '未设置'
                this.loginTypeName = loginTypeName || '未设置'
                this.sendType.value = sendType || 'MsgExternal'
                this.sendType.text = sendTypeName || '短信（非员工）'
                this.haveRange = haveRange
                this.onChange(loginType)
            })
        },
        showTip() {
            const message = `<div style="text-align:left;color:#333;font-size: .37rem;">1、手机号/UserId、扩展字段2、扩展字段3、扩展字段4，来源于导入模板中的数据；\n2、用户收到的问卷链接，是针对每个手机号/扩展字段生成的唯一问卷链接，便于后期统计分析用；\n3、短信发送速度预计150/分钟；\n4、发送名单支持导入excel表、接口调用；\n5、根据公司安全要求，【扩展字段ext1】中可填写userId或C01的密文手机号，不支持：明文、V1/V2格式的手机号；\n6、若接口调用，请参考：<a href="http://cwiki.guazi.com/pages/viewpage.action?pageId=250233766" style="color: #06B455;">http://cwiki.guazi.com/pages/viewpage.action?pageId=250233766</a>。</div>`
            Dialog.alert({
                title: '',
                message,
                }).then(() => {
            })
        },
        insert(value) {
            value = `{{${value}}}`
            let myField = document.getElementsByClassName('me-field__control')[0]
            if (myField.selectionStart || myField.selectionStart === 0) {
                let startPos = myField.selectionStart
                let endPos = myField.selectionEnd
                this.smsContent = myField.value.substring(0, startPos) + value + myField.value.substring(endPos, myField.value.length)
                this.$nextTick(()=>{
                    myField.focus()
                    myField.setSelectionRange(endPos + value.length, endPos + value.length)
                })
            } else {
                this.smsContent += value
            }
        },
        cancelPop() {
            this.show = false
        },
        confirmPop() {
            if (!this.file) {
                Toast.fail('请导入人员')
                return
            }
            var formData = new FormData()
            formData.append('file', this.file.file)
            formData.append('pageId', this.pageId)
            formData.append('type', 2)
            addClass2('body', 'loading')
            Questionnaire.importCustomer(formData, this.tid).then((res) => {
                Toast.success('发送成功！')
                this.show = false
                removeClass2('body', 'loading')
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        close() {
            this.show = false
        },
        save(btn) {
            if (!this.sendType.value) {
                Toast.fail('请设置通知类型')
                return true
            }
            if (this.loginType === 'Anonymous' && !this.haveRange && (this.sendType.value === 'MsgInternal' || this.sendType.value === 'IMChart') ) {
                Toast.fail('请指定发送范围')
                return true
            }
            if (this.loginType === 'RealName' && !this.haveRange) {
                Toast.fail('请指定发送范围')
                return true
            }
            if (this.signInfo.value === 'user_custom' && !this.customSignId) {
                Toast.fail('请填写模版服务ID')
                return true
            }
            let data = {}
            if (this.sendType.value === 'RemindTask') {
                data = {
                    tid: this.tid,
                    pageId: this.pageId,
                    sendType: this.sendType.value
                }
            } else if (this.signInfo.value === 'user_custom') {
                let smsContentList = this.smsContentList.map(item => {
                    return {
                        fieldCode: item.fieldCode,
                        enabled: item.enabled,
                    }
                })
                data = {
                    tid: this.tid,
                    pageId: this.pageId,
                    customSignId: this.customSignId,
                    smsContent: JSON.stringify(smsContentList),
                    signType: this.signInfo.value,
                    sendType: this.sendType.value
                }
            } else {
                if (!this.smsContent || (this.smsContent && !this.smsContent.trim())) {
                    Toast.fail(`${this.sendType.text}内容不能为空，请先添加${this.sendType.text}内容`)
                    return true
                }
                if (this.sendType.value !== 'IMChart' && /\n|\"/.test(this.smsContent)) {
                    Toast.fail('短信内容不能包含换行、英文双引号特殊字符')
                    return true
                }
                data = {
                    tid: this.tid,
                    pageId: this.pageId,
                    smsContent: this.smsContent,
                    signType: this.signInfo.value,
                    sendType: this.sendType.value
                }
            }
            btn === 'confirm' ? null : addClass2('body', 'loading')
            Questionnaire.questionConfig(data).then((res) => {
                    if (this.sendType.value !== 'MsgExternal') {
                        const data = {
                        pageId: this.pageId,
                        sendType: this.sendType.value
                    }
                    addClass2('body', 'loading')
                    if (btn === 'confirm') {
                        Questionnaire.getInternal(data, this.tid).then(res => {
                            removeClass2('body', 'loading')
                            Toast.success('发送成功！')
                        }).catch((error) => {
                            removeClass2('body', 'loading')
                            Toast.fail(error.response.data.message)
                        })
                    }
                }
                btn === 'confirm' ? null : Toast.success('保存成功！')
                btn === 'confirm' ? null : removeClass2('body', 'loading')
            }).catch((error) => {
                btn === 'confirm' ? null : removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        confirm() {
            if (!this.sendType.value) {
                Toast.fail('请设置通知类型')
                return
            }
            let notImport = this.save('confirm')
            if (notImport) return
            if (this.sendType.value === 'MsgExternal') {
                addClass2('body', 'loading')
                const data = {
                    tid: this.tid,
                    pageId: this.pageId,
                }
                Questionnaire.checkNotice(data).then((res) => {
                    removeClass2('body', 'loading')
                    let { data: { data } } = res
                    if (data) {
                        this.file = null
                        this.show = true
                        return
                    }
                    this.noticeDialog()
                }).catch((error) => {
                    if (error.response && error.response.data && error.response.data.message) {
                        Toast.fail(error.response.data.message)
                    }
                    removeClass2('body', 'loading')
                })
            }
        },
        noticeDialog() {
          const options = {
            message: '是否申请开通通知权限？',
            confirmFn: () => {
              addClass2('body', 'loading')
              const data = {
                tid: this.tid,
                pageId: this.pageId,
                perType: 'page',
                userCode: '',
              }
              Questionnaire.applyNotice(data).then(
                (res) => {
                  removeClass2('body', 'loading')
                  if (res.data.code == 'S00000') {
                    Toast.success('审批已提交，请耐心等待！')
                  }
                },
              ).catch((error) => {
                removeClass2('body', 'loading')
                console.log(error.response)
                Toast.fail(error.response.data.message)
              })
            },
            cancelFn: () => {}
          }
          this.$_dialog(options)
        },
        onOversize() {
            Toast('文件大小不能超过 1M')
        },
        afterRead(file) {
            this.file = file
        },
        getSignOptions() {
            return Questionnaire.getSignType({
                 tid: this.tid,
            }).then((res)=>{
                const {code, message, data} = res.data
                if(code === 'S00000'){
                    this.signOptions = data
                    return
                }
                Toast.fail(message)
            }).catch((error) => {
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
            })
        },
        onChange(value) {
            if (!value) return
            if (value === 'RealName') {
                this.$set(this.columnsNotice[0], 'disabled', true)
                this.$set(this.columnsNotice[3], 'disabled', false)
                if (this.sendType.value === 'MsgExternal') {
                    this.$set(this.sendType, 'value', '')
                    this.$set(this.sendType, 'text', '未设置')
                }
            } else {
                this.$set(this.columnsNotice[0], 'disabled', false)
                this.$set(this.columnsNotice[3], 'disabled', true)
                if (this.sendType.value === 'RemindTask') {
                    this.$set(this.sendType, 'value', '')
                    this.$set(this.sendType, 'text', '未设置')
                }
            }
        },
        onConfirmPicker(value, type) {
            if (type === 'sendType') {
                this.sendType = value
                this.showPopup2 = false
                return
            }
            this.signInfo = value
            this.showPopup1 = false
        },
        onCancelPicker() {
            this.showPopup1 = false
            this.showPopup2 = false
        },
        showPopSign() {
            this.showPopup1 = true 
        },
        showPopNotice() {
            this.showPopup2 = true 
        }
    },
}
</script>
<style scoped lang="scss">
    .base_content {
        ::v-deep .me-hairline--top-bottom::after, .me-hairline-unset--top-bottom::after {
            border-width: 0 0;
        }
    }
    .defined-span {
        padding: 0px 0.58667rem 0.26667rem;
        font-size: 0.31rem;
    }
    .notice-content{
        padding-bottom: 2.66667rem;
        .types{
            display: flex;
            justify-content: space-between;
            margin: 0.3rem .53rem;
        }
        .content_text {
            padding: .42rem;
        }
        .content{
            font-size: 0.37333rem;
            background: #fff;
            .texts{
                margin: .4rem 0;
                display: flex;
                justify-content: space-between;
                >span{
                    cursor: pointer;
                    text-decoration: underline;
                    color: #06B455;
                }
            }
            .tip{
                margin-top: .5rem;
                margin-bottom: .2rem;
                color: rgba(69, 90, 100, 0.6);
                font-size: .32rem;
                &::before{
                    content: '';
                    display: inline-block;
                    margin-right: .1rem; 
                    width: .32rem;
                    height: .32rem;
                    background: url(../images/warning.png) no-repeat;
                    background-size: cover;
                    vertical-align: -.03rem;
                }
                // >span{
                //     color: #2c3e50;
                // }
            }
            .send-tip{
                padding: 10px 10px;
                text-decoration: underline;
                .info-o{
                    vertical-align: -.08rem;
                    font-size: .43rem;
                    margin-right: .1rem;
                }
            }
        }
        .not-yet{
            opacity: 0;
        }
    }
    .dialog-content{
        padding: .3rem;
        .import-btn{
            display: inline-block;
            padding: 0.2rem 0.5rem;
            width: 2.6rem;
            border: 0.02667rem solid #06B455;
            border-radius: 0.1rem;
            font-size: 0.37rem;
            box-sizing: border-box;
            text-align: center;
        }
        .down{
            margin-left: 1rem;
            color: #06B455;
            text-decoration: underline;
            font-size: .37rem;
        }
        .notice{
            display: flex;
            font-size: .32rem;
            margin: 0.6rem 0 .2rem;
            color: #5F6670;
        }
        .file{
            margin-bottom: .6rem;
            display: flex;
            justify-content: space-between;
            font-size: 0.37rem;
            .fileName{
                flex: 1;
            }
            .del{
                display: inline-block;
                margin-left: .5rem;
                width: 1rem;
                text-decoration: underline;
            }
        }
    }
    .defined-group{
        &:after{
            border-top: none;
        }
        ::v-deep .me-cell {
            padding: 0 0.58667rem;
            line-height: 1.38667rem;
        }
    }
    .desc-tip {
        padding: 0 0.58667rem 0.2rem;
        color: rgba(69, 90, 100, 0.6);
        font-size: 0.32rem;
    }
    .defined-cell{
        // margin-bottom: 20px;
        i[class^="me-icon"]{
            top: 19px;
        }
    }
    .defined-field {
        ::v-deep .me-field__control {
            background-color: #fff;
        }
    }

    ::v-deep .me-cell:not(.defined-cell){
        padding: 0;
    }
    ::v-deep .me-cell::after{
        border: none;
    }
    ::v-deep .me-field__body{
        border-radius: .1rem;
        background: #F6F6F6;
    }
    ::v-deep .me-field__control{
        padding: .1rem;
    }
    .cell_bottom {
        margin-bottom: 0px;
    }
</style>
